module.exports = __webpack_public_path__ + "media/images/sync-icon-e2d80baa000c1fa0b28d0fa68ced17c7.svg";